import * as React from "react";
import classNames from "classnames";

interface IAccordionContentProps {
    className?: string;
}

const AccordionContent: React.FC<IAccordionContentProps> = props => {
    const rootClasses = classNames("accordion-content", props.className);
    return <div className={rootClasses}>{props.children}</div>;
};

export default AccordionContent;
